import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

api.interceptors.response.use(undefined, async (error) => {
  const cfg = error?.config;
  if (error?.response?.status === 401 && cfg && !cfg._retried && !["/auth/login", "/auth/refresh"].includes(cfg.url)) {
    cfg._retried = true;
    await api.post("/auth/refresh");
    return api(cfg);
  }
  return Promise.reject(error);
});

export const imgSrc = (path) => (path && path.startsWith("/api/") ? `${BACKEND_URL}${path}` : path || "");

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? `${x.loc?.slice(-1)[0] ?? ""} ${x.msg}`.trim() : JSON.stringify(x))).join(" · ");
  return typeof d?.msg === "string" ? d.msg : String(d);
};
